// link
import linkedInLogo from "assets/images/svg/icons8-linkedin-logo.svg";
import githubLogo from "assets/images/svg/icons8-github.svg";
import youTubeLogo from "assets/images/svg/icons8-youtube-logo.svg";
import InstagramLogo from "assets/images/svg/icons8-instagram-logo.svg";

// footerIcons
import linkedIn from "assets/images/socialIcons/linkedin.svg";
import github from "assets/images/socialIcons/github.svg";
import youTube from "assets/images/socialIcons/youtube.svg";
import Instagram from "assets/images/socialIcons/instagram.svg";

export const HeaderLinks = [
  {
    name: "Home",
    id: "banner"
  },
  {
    name: "About",
    id: "about"
  },
  {
    name: "Projects",
    id: "project"
  },
  {
    name: "Contact",
    id: "contact"
  }
];

export const socialLinks = [
  {
    linkTo: "https://www.linkedin.com/in/yogesh-s-303b0b203",
    image: linkedInLogo
  },
  {
    linkTo: "https://www.youtube.com/@UnboxCoders",
    image: youTubeLogo
  },
  {
    linkTo: "https://github.com/12Yoge",
    image: githubLogo
  },
  {
    linkTo:
      "https://www.instagram.com/dev.innovative?utm_source=qr&igsh=MWF5aDg4NTNlb3A4dA==",
    image: InstagramLogo
  }
];

export const mySkills = [
  {
    name: "HTML"
  },
  {
    name: "CSS"
  },
  {
    name: "SASS"
  },
  {
    name: "GIT"
  },
  {
    name: "GitHub"
  },
  {
    name: "GitLab"
  },
  {
    name: "BitBucket"
  },
  {
    name: "SEO"
  },
  {
    name: "Terminal"
  },
  {
    name: "Responsive Design"
  },
  {
    name: "JavaScript"
  },
  {
    name: "ReactJs"
  },
  {
    name: "Email Js"
  },
  {
    name: "Wordpress-api"
  },
  {
    name: "Webflow"
  }
];

export const socialFooterLinks = [
  {
    linkTo: "https://www.linkedin.com/in/yogesh-s-303b0b203",
    image: linkedIn
  },
  {
    linkTo: "https://www.youtube.com/@UnboxCoders",
    image: youTube
  },
  {
    linkTo: "https://github.com/12Yoge",
    image: github
  },
  {
    linkTo:
      "https://www.instagram.com/dev.innovative?utm_source=qr&igsh=MWF5aDg4NTNlb3A4dA==",
    image: Instagram
  }
];
